import {
  AppChannel,
  PaymentInitiation,
  PaymentMethod,
  PaymentProvider,
  PaymentProviderId,
  PaymentRequest,
  PaymentReturn,
  PaymentVerification,
  ProviderCapabilities,
} from '../types';

/**
 * ─── OrangeMoneyProvider (squelette, en attente de documentation) ───────────
 *
 * Provider EXCLUSIF de la Super App Maxit : Orange impose que, quand le trafic
 * passe par Maxit, le paiement se fasse uniquement par Orange Money.
 *
 * La documentation Orange Money n'étant pas encore disponible, `initiate` et
 * `verify` lèvent une erreur explicite « non branché » — exactement comme les
 * squelettes FlexPay / M-Pesa. En attendant, le mode Mock (/admin/payments)
 * permet de tester tout le flow Maxit sans backend.
 *
 * BRANCHEMENT FUTUR (à réception de la doc Orange Money) :
 *   1. Compléter `initiate` / `verify` avec les appels au backend de l'app.
 *   2. Confirmer les marqueurs de détection Maxit dans services/channel.ts
 *      (préfixe `/maxit`, bridge natif, User-Agent).
 *   3. Activer le provider Orange dans /admin/payments.
 * Aucun autre fichier du module ne doit changer.
 */
export class OrangeMoneyProvider implements PaymentProvider {
  readonly id = PaymentProviderId.ORANGE;
  readonly displayName = 'Orange Money';
  readonly capabilities: ProviderCapabilities = {
    methods: [PaymentMethod.ORANGE_MONEY],
    currencies: ['USD', 'CDF'],
    usesRedirect: false, // hypothèse (push/validation) ; à confirmer avec la doc
  };

  supportsChannel(channel: AppChannel): boolean {
    // Orange Money ne sert que la Super App Maxit.
    return channel === AppChannel.MAXIT;
  }

  async initiate(_request: PaymentRequest): Promise<PaymentInitiation> {
    // TODO(doc Orange): POST <api>/payments/orange/initiate
    //  → return { kind: 'push_sent', orderNumber, instructions } (probable)
    throw new Error(
      'OrangeMoneyProvider non branché : en attente de la documentation Orange Money.',
    );
  }

  async verify(_orderNumber: string): Promise<PaymentVerification> {
    // TODO(doc Orange): GET <api>/payments/orange/status/{orderNumber}
    throw new Error(
      'OrangeMoneyProvider non branché : en attente de la documentation Orange Money.',
    );
  }

  parseReturn(params: URLSearchParams): PaymentReturn | null {
    if (params.get('provider') !== this.id) return null;
    const outcome = params.get('outcome');
    if (outcome !== 'approved' && outcome !== 'cancelled' && outcome !== 'declined') {
      return null;
    }
    return {
      outcome,
      reference: params.get('reference'),
      orderNumber: params.get('orderNumber'),
    };
  }
}
